// extracted by mini-css-extract-plugin
export var modalFooter = "_li-0";